<template>
    <div class="form-actions">
        <button class="btn btn-primary" @click="$emit('save')">保存</button>
        <button class="btn btn-secondary" @click="$emit('cancel')">キャンセル</button>
    </div>
</template>

<script>
export default {
    name: "TodoFormActions"
};
</script>

<style scoped>
.form-actions {
    display: flex;
    margin-top: 16px;
    width: 100%;
    justify-content: flex-end;
}

.btn {
    padding: 7px 0;
    width: 146px;
    height: 44px;
    border-radius: 2px;
    border: none;
    font-weight: 600;
    cursor: pointer;
    margin-left: 8px;
}

.btn-primary {
    background: #03a9f4;
    color: #fff;
}

.btn-secondary {
    background: #f4f4f4;
    color: #333;
    border: 1px solid #ccc;
}
</style>